import { useQuery, useMutation } from "@apollo/client";
import {
  CHAT_INTEGRATION,
  AVAILABLE_BROADCAST_CHANNELS,
  INITIATE_CHAT_INTEGRATION,
  SELECT_BROADCAST_CHANNEL,
  UPDATE_BROADCAST_SETTINGS,
  DISCONNECT_CHAT_INTEGRATION,
  REFRESH_CHAT_INTEGRATION_STATUS,
  TEST_BROADCAST,
} from "../graphql";
import type {
  ChatIntegration,
  BroadcastChannel,
} from "../types";

// ─── Queries ─────────────────────────────────────────────────────────────────

export function useChatIntegration(organizationId: string) {
  return useQuery<{ chatIntegration: ChatIntegration | null }>(
    CHAT_INTEGRATION,
    {
      variables: { organizationId },
      skip: !organizationId,
      fetchPolicy: "cache-and-network",
    },
  );
}

export function useAvailableBroadcastChannels(organizationId: string, skip = false) {
  return useQuery<{ availableBroadcastChannels: BroadcastChannel[] }>(
    AVAILABLE_BROADCAST_CHANNELS,
    {
      variables: { organizationId },
      skip: !organizationId || skip,
      fetchPolicy: "network-only",
    },
  );
}

// ─── Mutations ───────────────────────────────────────────────────────────────

export function useInitiateChatIntegration() {
  return useMutation<{ initiateChatIntegration: string }>(
    INITIATE_CHAT_INTEGRATION,
  );
}

export function useSelectBroadcastChannel() {
  return useMutation(SELECT_BROADCAST_CHANNEL, {
    refetchQueries: ["ChatIntegration"],
  });
}

export function useUpdateBroadcastSettings() {
  return useMutation(UPDATE_BROADCAST_SETTINGS, {
    refetchQueries: ["ChatIntegration"],
  });
}

export function useDisconnectChatIntegration() {
  return useMutation(DISCONNECT_CHAT_INTEGRATION, {
    refetchQueries: ["ChatIntegration"],
  });
}

export function useRefreshChatIntegrationStatus() {
  return useMutation(REFRESH_CHAT_INTEGRATION_STATUS, {
    refetchQueries: ["ChatIntegration"],
  });
}

export function useTestBroadcast() {
  return useMutation<{ testBroadcast: boolean }>(TEST_BROADCAST);
}
